import {useSuspenseQuery} from '@tanstack/react-query';

import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getContactData} from 'presentation/services/getContactData';

export const useContactDataQuery = () =>
	useSuspenseQuery({
		queryKey: [QUERY_KEYS.CONTACT_DATA],
		queryFn: async ({signal}) => getContactData(signal),
	});
